var script = {
  name: 'PendoNotificationCount',
  props: {
    count: {
      type: Number,
      required: true
    },
    size: {
      type: Number,
      default: 20
    },
    showCount: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    backgroundStyles() {
      return {
        height: `${this.size}px`,
        width: `${this.width}px`,
        fontSize: `${this.size}px`,
        backgroundColor: '#ff0000',
        color: '#ffffff',
        borderRadius: `${this.size}px`
      };
    },
    countStyles() {
      return {
        fontSize: '.6em'
      };
    },
    width() {
      if (this.count < 10 || !this.showCount) {
        return this.size;
      }
      if (this.count < 100) {
        return this.size * 1.5;
      }
      return this.size * 2;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-notification-count.vue2.js.map
